import axios from 'axios';

const getAxios = () => {
  return axios.create({
    baseURL: process.env.REACT_APP_API
  });
};

export const registerUserIntoDepartment = (name, email, phone, companyId, departmentId, cpf ,userId) => {
  return getAxios().post('employees/autosignup?XDEBUG_SESSION_START=PHPSTORM', {
    name,
    email,
    phone,
    companyId,
    departmentId,
    cpf,
    userId
  });
};

export const registerUserByCpf = (name, email, phone, companyId, userId) => {
  return getAxios().post('employees/cpf_register?XDEBUG_SESSION_START=PHPSTORM', {
    name,
    email,
    phone,
    companyId,
    userId
  });
};

export const loadCompanyDetails = (hash, isCpfRegistration) => {
  let path = isCpfRegistration ? 'magiclink/company/check/' : 'magiclink/department/check/';
  return getAxios().get(`${path + hash}?XDEBUG_SESSION_START=PHPSTORM`);
};

export const verifyEmailService = (email, companyId, departmentId) => {
  return new Promise((resolve, reject) => {
    getAxios().post(`company/email/`, {
      email,
      companyId,
      departmentId,
    }).then(response => {
      if (response.status === 200 && response.data.userId === 0) {
        response.data.userId = null; // Clears the data
        resolve(response);
      } else {
        reject();
      }
    }).catch(error => {
      reject(error);
    })
  });
};

export function CpfNotFoundException() {}
export function CpfAlreadyRegisteredException() {}

export const verifyCpfService = (cpf, companyId) => {
  return new Promise((resolve, reject) => {
    getAxios().post(`company/cpf/?XDEBUG_SESSION_START=PHPSTORM`, {
      cpf,
      companyId
    }).then(response => {
      resolve(response);
    }).catch(error => {
      if (error.response) {
        if (error.response.status === 409) {
          reject(new CpfAlreadyRegisteredException());
        } else if (error.response.status === 404) {
          reject(new CpfNotFoundException());
        } else {
          reject(new Error("Unknown error"));
        }
      } else {
        reject(new Error("Unknown error"));
      }
    })
  });
};


// WEBPACK FOOTER //
// ./src/services/httpServices.js